import {
  FETCH_FAVORITE_CHANNELS_INIT,
  FETCH_FAVORITE_CHANNELS_SUCCESS,
  FETCH_FAVORITE_CHANNELS_ERROR,
  TOGGLE_SHOW_FAVORITE_CHANNELS,
  ADD_CHANNEL_TO_FAVORITE,
  REMOVE_CHANNEL_FROM_FAVORITE,
} from '../actions/favorite/constants';

const initialState = {
  loading: false,
  channels: [],
  error: null,
  isShowing: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FAVORITE_CHANNELS_INIT:
      return {
        ...state,
        loading: true,
        channels: [],
        error: null,
      };
    case FETCH_FAVORITE_CHANNELS_SUCCESS:
      return {
        ...state,
        loading: false,
        channels: action.data,
        error: null,
      };
    case FETCH_FAVORITE_CHANNELS_ERROR:
      return {
        ...state,
        loading: false,
        channels: [],
        error: action.error,
      };
    case TOGGLE_SHOW_FAVORITE_CHANNELS:
      return {
        ...state,
        isShowing: action.payload,
      };
    case ADD_CHANNEL_TO_FAVORITE:
      return {
        ...state,
        channels: [
          ...state.channels,
          {
            id: action.data,
          },
        ],
      };
    case REMOVE_CHANNEL_FROM_FAVORITE: {
      const idx = state.channels.findIndex(
        channel => channel.id === action.data,
      );
      state.channels.splice(idx, 1);
      return {
        ...state,
        channels: [...state.channels],
      };
    }
    default:
      return state;
  }
};
